import { useMemo } from 'react';

import { type TableNamesWithAnyFilters } from '../../features/assortment-filters/types';
import { useAssortmentSessionStorageAtom } from '../../storage/session-storage';

export const useGetAvailableFilterStates = (
  tableName: TableNamesWithAnyFilters,
) => {
  const [generalFiltersState] = useAssortmentSessionStorageAtom(
    `${tableName}.generalFilters`,
  );
  const [advancedFiltersState] = useAssortmentSessionStorageAtom(
    `${tableName}.advancedFilters`,
  );

  const availableFiltersState = useMemo(() => {
    if (
      generalFiltersState !== undefined &&
      advancedFiltersState !== undefined
    ) {
      return ['general', 'advanced'] as const;
    } else if (advancedFiltersState) {
      return ['advanced'] as const;
    } else if (generalFiltersState) {
      return ['general'] as const;
    }
    return [] as const;
  }, [generalFiltersState, advancedFiltersState]);

  if (availableFiltersState.length === 0) {
    throw new Error(`${tableName} does not support any filters`);
  }
  return availableFiltersState;
};
